import { useSelector } from 'react-redux';

import OverridesLoader from 'organisms/Loaders/OverridesLoader';

import Overrides from './Overrides';

export default function OverrideSection({ inSingleDayPanel }) {
  const { isLoadingInventory } = useSelector((state) => state.inventory);

  return (
    <div className="override-availability w-100 mb-12 p-24 border-light-purple radius-24">
      <div className="override-availability-header">
        <h4 className="f16 mb-5">Unavailable time</h4>
        <p className="f13">This will block any appointments being made.</p>
      </div>
      <div className="flex-column overrides-container">
        {isLoadingInventory ? (
          <OverridesLoader />
        ) : (
          <Overrides inSingleDayPanel={inSingleDayPanel} />
        )}
      </div>
    </div>
  );
}
